import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HoldingLayout } from './components/layout/HoldingLayout';
import Placeholder from './pages/Placeholder';
import Contact from './pages/Contact';

/**
 * Public site = holding experience only (AI / future of medicine).
 *
 * Preserved for later rebuild (import when ready — not routed):
 *   ./pages/Home
 *   ./pages/About
 *   ./pages/Technology
 *   ./components/layout/PageLayout (Navbar + Footer)
 */

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function NavigationTracker() {
  const location = useLocation();
  const previousPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousPathRef.current;

    if (previousPath !== currentPath) {
      sessionStorage.setItem('previousPath', previousPath);
      window.scrollTo(0, 0);
    }

    previousPathRef.current = currentPath;
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <NavigationTracker />
      <HoldingLayout>
        <Routes>
          <Route path="/" element={<Placeholder />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Placeholder />} />
        </Routes>
      </HoldingLayout>
    </BrowserRouter>
  );
}

export default App;
